import React, { FC, useEffect, useState } from 'react';
import { ToggleButton, Flex, View } from '@adobe/react-spectrum';
import Camera from '@spectrum-icons/workflow/Camera';
import { canvasObservable, CanvasEvent, ICanvasMode } from '~/Services/Studio/Canvas/canvasObservable';
import { _system } from '~/Services/Studio/studioScene';
import { setVideoFirstFrame } from '~/Services/Studio/Plugins/pointOfView';

export const CanvasScreenshot: FC = () => {
    const [show, setShow] = useState<boolean>(false);
    const [mode, setMode] = useState<ICanvasMode>();
    const addPov = () => {
        if (mode === 'screenshot') {
            return canvasObservable.screenshot();
        }
        const geo = _system.getCurrentCameraGeometry();
        setVideoFirstFrame(geo);
        return canvasObservable.notify(CanvasEvent.VideoFrame, geo);
    };

    useEffect(() => {
        canvasObservable.on(CanvasEvent.ShowFrame, (page: ICanvasMode) => {
            setMode(page);
            setShow(true);
        });
        canvasObservable.on(CanvasEvent.ShowScreenshot, () => {
            setMode('screenshot');
            setShow(true);
        });
        canvasObservable.on(CanvasEvent.HideFrame, () => {
            setShow(false);
        });
    }, []);

    if (show) {
        return (
            <Flex
                flex
                alignItems="center"
                direction="column"
                gap="size-100"
                position="absolute"
                zIndex={2}
                bottom="20px"
                left="calc(50% - size-600 / 2)"
            >
                <View backgroundColor="gray-100" borderRadius="medium">
                    <ToggleButton onPress={addPov} height="size-700" width="size-700">
                        <Camera height="size-400" width="size-400" />
                    </ToggleButton>
                </View>
            </Flex>
        );
    }
    return (<></>);
};
